export const KNOWLEDGE_BASE_URL = {
  OPEN_TAGS:
    'https://knowledge-base.yieldbird.com/yieldbird-platform/yieldbird-platform-implementation-overview/yieldbird-tags-implementation/open-tags',
  SMART_TAGS:
    'https://knowledge-base.yieldbird.com/yieldbird-platform/yieldbird-platform-implementation-overview/yieldbird-tags-implementation/smart-tags',
  TAGS_IMPLEMENTATION:
    'https://knowledge-base.yieldbird.com/yieldbird-platform/yieldbird-platform-implementation-overview/yieldbird-tags-implementation',
} as const
